export const getSharedAndPrivateFiles = (fileList = []) => {
  const orderFilesExist = fileList.filter(item => item.orderFileExists === 1).length > 0;
  const sharedFilesExist = fileList.filter(item => item.sharedFileExists === 1).length > 0;
  const privateFilesExist = fileList.filter(item => item.privateFileExists === 1).length > 0;

  if (orderFilesExist && sharedFilesExist && privateFilesExist) {
    return 'all';
  } else if (orderFilesExist && !sharedFilesExist && !privateFilesExist) {
    return 'order';
  } else if (!orderFilesExist && sharedFilesExist && !privateFilesExist) {
    return 'shared';
  } else if (!orderFilesExist && !sharedFilesExist && privateFilesExist) {
    return 'private';
  } else if (orderFilesExist && sharedFilesExist && !privateFilesExist) {
    return 'order-shared';
  } else if (orderFilesExist && !sharedFilesExist && privateFilesExist) {
    return 'order-private';
  } else if (!orderFilesExist && sharedFilesExist && privateFilesExist) {
    return 'shared-private';
  } else {
    return null;
  }
};

export const filterFileListByFileTypeId = (fileList = [], fileTypeId) => fileList.filter(item => {
  return item.fileTypeID === fileTypeId || item.fileTypeID === 0
});

export const getFileFolderID = (data = [], fileTypeID) => {
  if (data && data.length > 0) {
    const row = data
      .filter(item => item.fileTypeID === fileTypeID)
      .map(item => item.folderID)
      .filter(Boolean)

    return row.length > 0 ? row[0] : null
  } else return null
};